import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignBlocksLeftSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 1H1v10h1V1zm1 2h8v2H3V3zm0 4h5v2H3V7z" />
  </svg>
);
export default IconAlignBlocksLeftSizeXs;
